import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  ...zhLocale,
  menu: {
    'Home': '首页',
    '404': '404',
    '403': '403',
    '500': '500',
    'Login': '登陆',
    'AuditProcess': '信审管理',
    'UserManage': '用户管理',
    'UserManageList': '用户信息管理',
    'UserWhiteList': '用户白名单管理',
    'CloseUserRecord': '注销记录查询',
    'CreditWhiteList': '额度白名单管理',
    'Financial': '财务管理',
    'TransactionManageList': '交易流水',
    'MerchantWithdrawConfirm': '商户提现放款',
    'CollectionManage': '催收管理',
    'RepaymentPlanList': '待还款账单',
    'FlatAccountRecords': '平账记录',
    'Marketing': '营销管理',
    'CommentsList': '评论列表',
    'Configuration': '配置管理',
    'FaqManageList': 'FAQ',
    'System': '系统管理',
    'SystemDepartment': '公司架构',
    'SystemUser': '员工列表',
    'SystemRole': '角色管理',
    'SystemPermission': '权限管理',
    'SystemMenu': '菜单管理',
  },

  page: {
    'Home': '首页',
    '404': '404',
    '403': '403',
    '500': '500',
    'Login': '登陆',
    'Upload': '上传图片',
    user: '用户管理',
    'app:user:manage': '用户信息管理',
    'app:user:userWhiteList': '用户白名单管理',
    'app:user:closeUserRecord': '注销记录查询',
    'app:user:manage:detailInfo': '用户详情',
    'app:user:manage:auditDetailInfo': '用户审核详情',
    'app:user:creditWhiteList': '额度白名单管理',
    'operation:feedback': '反馈',
    'app:user:tadpole': '蝌蚪贷屏蔽用户管理',
    financial: '财务管理',
    'transaction:manage': '交易流水',
    'merchant:withdraw:confirm': '商户提现放款',
    'debtBuyback:manage': '债权回购',
    collection: '催收管理',
    'collection:manage:repaymentPlanList': '待还款账单',
    'collection:manage:flatAccountRecords': '平账记录',
    order: '订单管理',
    'app:order:quickloan': '快速贷',
    'app:order:cashoyo': 'Cashoyo Loan',
    'order:cashoyoLoan': 'Cashoyo Loan',
    'order:consumeList': '用户消费订单',
    'order:refundList': '退款处理记录',
    mpay: 'MPay',
    'mpay:reconciliation': 'MPay对账',
    'mpay:reconciliation:list': 'MPay 对账记录',
    'mpay:reconciliation:cps': 'CPS 对账记录',
    'mpay:reconciliation:fixlog': '修复记录',
    'mpay:cashFlowAnalysis': 'Mpay现金流分析',
    marketing: '营销管理',
    'app:commentsList:manage': '评论列表',
    'coupon': '优惠券列表',
    notice: '消息通知',
    'notice:job:list': '任务',
    'notice:sql:list': 'SQL',
    'notice:tmp:list': '模板',
    'notice:job:jobExecuteLog': '任务执行记录',
    'notice:weight': '消息权重配置',
    'notice:successRate': '发送成功率',
    'notice:blackList': '消息黑名单',
    configuration: '配置管理',
    'shortLink:manage': '短链接 (Manual)',
    'shortLinkAuto:manage': '短链接 (Auto)',
    'faq:manage': 'FAQ',
    'app:banner:manage': 'Banner',
    'app:category:manage': 'Category',
    system: '系统管理',
    'system:department': '公司架构',
    'system:user': '员工列表',
    'system:role': '角色管理',
    'system:menu': '菜单管理',
    'system:log': '操作日志',
    'app:announcement:manage': '公告配置',
    product: 'B/L/E 产品维护',
    'product:category': '分类',
    'product:brand': '品牌',
    'product:productListByVendor': '产品列表',
    'funder': '资金方',
    'funder:routerList': '资金方路由',
    'funder:checkOrderList': '资金方审核订单',
    'funder:ownbankRepaymentList': 'ownbank还款记录',
    'funder:ownbankStatementList': 'ownbank结算记录',
    'funder:ownbankPayoutList': 'ownbank转账记录',
    'funder:getIncomeLoanList': 'GetIncome贷款',
    loanMarket: '贷超管理',
    'loanMarket:merchantProductList': '商户产品',
    'loanMarket:parentList': '贷超列表',
    'loanMarket:parentFrontList': '甲方贷超列表',
    'loanMarket:merchantList': '商户管理',
    'loanMarket:tagList': '标签管理',
    'loanMarket:merchantProductList:detailInfo': '商户产品详情',
    'loanMarket:showConfigList': '展示配置',
    complaint: '投诉受理',
    'complaint:pendingList': '待处理投诉',
    'complaint:processedList': '已处理投诉',
      tele: '电销管理',
      'tele:cases': '电销列表',
      'tele:cases:detail': '电销详情',
      'tele:ccbar': '电销席位',
      'tele:caseAppoint': '预约电销列表',
      'tele:callTask': '外呼任务列表',
      'tele:strategyList': '策略列表'
  },
    
  'tip:tip': '提示',
  'tip:pleaseSelect': '请先选择需要操作的数据',
  'tip:pleaseSelect2': '请先选择一个人员再点击',
  'tip:sureSubmit': '确认提交吗？',
  'tip:sureCancel': '确认取消吗？',
  'tip:sureDelete': '确认删除吗？',
  'tip:selectDelete': '请先选择要删除的对象',
  'tip:operateSuccessTip': '操作成功',
  'tip:operateErrorTip': '操作失败',
  'tip:sendSmsSuccessTip': '发送成功',
  'tip:sendSmsErrorTip': '发送失败',
  'tip:required': '不能为空',
  'tip:amountFormatErrorTip': '请输入正确的金额',
  'tip:creditWhiteListErrorTip': '取现额度不可大于总额度',
  'tip:upload:uploadBtn': '点击上传',
  'tip:upload:uploadTip': '请上传 [fileTypeName] 文件，且不超过 [fileSize] MB',
  'tip:upload:uploadTip2': '将文件拖到此处，或点击上传',
  'tip:upload:uploadTip3': '支持扩展名',
  'tip:upload:uploadTip4': '请先上传文件',
  'tip:upload:fileTypeTip': '文件格式不正确, 请上传以下格式文件：[fileTypeName]',
  'tip:upload:fileSizeTip': '文件大小不能超过 [fileSize] MB',
  'tip:upload:uploadSuccess': '上传成功',
  'tip:upload:uploadError': '上传失败, 请重试',
  'tip:upload:uploadLimitError': '超出上传文件个数,请删除以后再上传！',
  'tip:sureJoinBlackList': '确定加入黑名单吗?',
  'tip:sureRemoveBlackList': '确定移除黑名单吗?',
  'tip:sureEnable': '确定置为生效?',
  'tip:sureDisable': '确定置为失效?',
  'tip:validatorNumber': '请输入数字',
  'tip:validatorNumber1': '请输入正确的数字，不能为小数',
  'tip:validatorNumber2': '请输入数字，最多1位小数',
  'tip:validatorNumber3': '请输入数字，不超过100',
  'tip:storeCategoryTip': '上级分类不能为其本身或其子分类',
  'tip:logoutReasonRequired': '注销原因不能为空',
  'tip:sureLogout': '确定注销吗？',
  'tip:sureCancelLogout': '确定恢复该用户吗？',
  'tip:sureChangeBankCard': '确认更改商户银行卡吗？',
  'tip:allowEditTip': '只有审核通过状态的商户才允许修改，请检查',
  'tip:deparentmentTip1': '上级部门不能为其本身',
  'tip:deparentmentTip2': '不能修改Mocasa的上级部门',
  'tip:businessHoursTip1': '开始时间必须大于上一个时间段的结束时间',
  'tip:businessHoursTip2': '结束时间必须大于开始时间',
  'tip:changeTransactionMobileTip': '手机号不能重复，请检查',
  'tip:validatorMobile': '请输入正确的手机号',
  'tip:changePasswordTips1': 'The password must be 12 characters or longer, consisting of both uppercase and lowercase letters, special characters and numbers. It should also be a strong password that is not consecutive or repetitive.',
  'tip:changePasswordTips2': 'The two newly entered passwords are not the same.',
  
  'base:userId': '用户Id',
  'base:userName': '用户姓名',
  'base:userMobile': '用户手机号',
  'base:submissionTime': '提交时间',
  'base:addBlackTime': '拉黑时间',
  'base:variableName': '变量名称',
  'base:bdId': 'BD ID',
  'base:bdName': 'BD姓名',
  'base:bdNumber': 'BD工号',
  'base:bdAccount': 'BD账号',
  'base:status': '状态',
  'base:reviewStatus': '审核状态',
  'base:addReason': '添加原因',
  'base:keyword': '关键字',
  'base:remark': '备注',
  'base:roleName': '角色名',
  'base:roleCode': '角色Code',
  'base:roleDesc': '角色描述',
  'base:addTime': '添加时间',
  'base:createTime': '创建时间',
  'base:updateTime': '更新时间',
  'base:modifiedTime': '修改时间',
  'base:createName': '创建人',
  'base:updateName': '更新人',
  'base:isValid': '是否生效',
  'base:lastModifyUser': '最后一次修改人',
  'base:lastModifyTime': '最后一次修改时间',
  'base:uploadImg': '上传图片',
  'base:addressId': '地址ID',
  'base:addressName': '地址名称',
  'base:parentAddress': '上级地址',
  'base:time': '时间',
  'base:startTime': '开始时间',
  'base:endTime': '结束时间',
  'base:onlineReason': '上线原因',
  'base:offlineReason': '下线原因',
  'base:reason': '原因',
  'base:phone': '手机号',
  'base:name': '姓名',
  'base:source': '来源',
  'base:creditLine': '总额度',
  'base:withdrawLine': '取现额度',

  'base:feedbackTime': '反馈时间',
  'base:feedbackType': '反馈类型',
  'base:feedbackType1': '投诉',
  'base:feedbackType2': '建议',
  'base:contactType': '联系类型',
  'base:contact': '联系方式',
  'base:context': '描述',
  'base:uploadPicUrl': '图片',
  'base:loanProducts': '贷超产品',
  'base:replyDialogTitle': '反馈回复',
  'base:replyStatus': '状态',
  'base:replyStatus0': '未处理',
  'base:replyStatus1': '已处理',
  'base:newReplyStatus0': '未知',
  'base:newReplyStatus1': '已提交',
  'base:newReplyStatus2': '已受理',
  'base:newReplyStatus3': '处理中',
  'base:newReplyStatus4': '已完成',

  'base:operationAccount': '操作账号',
  'base:operationTime': '操作时间',
  'base:operationMode': '操作模块',
  'base:operationType': '操作类型',
  'base:operationSource': '操作来源',
  'base:operationIp': '操作IP',
  'base:operationContent': '操作内容',
  'base:newOrders': '累计新单',
  'base:reprocess': '驳回重审',

  'base:sqlId': 'SQL ID',
  'base:sqlName': 'SQL名称',
  'base:filterType': '排除类型',
  'base:purpose': '目的',
  'base:tpl': '模版',
  'base:tplId': '模版ID',
  'base:tplName': '模版名称',
  'base:tplTitle': '模版标题',
  'base:extendJson': '扩展参数',
  'base:thirdPartTemplate': '第三方模版',
  'base:tplContent': '模版内容',
  'base:JobId': '任务ID',
  'base:JobName': '任务名称',
  'base:startDate': '开始日期',
  'base:sendTime': '发送时间',
  'base:lastSendTime': '最后一次发送时间',
  'base:sendInterval': '发送间隔(分钟)',
  'base:groupName': '组名',
  'base:sendType': '发送类型',
  'base:contentType': '分类',
  'base:sendRate': '发送百分比',
  'base:sendCost': '发送成本',
  'base:enterSearch': '请输入关键词搜索',
  'base:jobConfigIds': '任务配置ID',
  'base:completeTime': '完成时间',
  'base:replaceShortUrl': '是否转短链',
  'base:type': '类型',

  'action:changePassword': '修改密码',
  'action:add': '新增',
  'action:batchAdd': '批量新增',
  'action:batchOperation': '批量操作',
  'action:view': '查看',
  'action:viewSQL': '查看SQL',
  'action:edit': '修改',
  'action:submit': '提交',
  'action:confirm': '确认',
  'action:save': '保存',
  'action:cancel': '取消',
  'action:back': '返回',
  'action:delete': '删除',
  'action:start': '启动',
  'action:stop': '停止',
  'action:batchDelete': '批量删除',
  'action:search': '搜索',
  'action:reset': '重置',
  'action:detail': '详情',
  'action:operate': '操作',
  'action:modify': '允许前端修改',
  'action:preview': '预览',
  'action:more': '更多',
  'action:join': '加入',
  'action:remove': '移除',
  'action:joinBlack': '加入黑名单',
  'action:removeBlack': '移除黑名单',
  'action:updateCreditLine': '修改额度',
  'action:raise': '₱ 提额',
  'action:batchRaise': '₱ 批量提额',
  'action:logout': '注销',
  'action:cancelLogout': '恢复',
  'action:assignPermission': '权限分配',
  'action:import': '导入',
  'action:audit': '审核',
  'action:downloadTemplate': '下载模版',
  'action:pass': '通过',
  'action:reject': '拒绝',
  'action:refundAction': '退款按钮',
  'action:refund': '退款',
  'acton:reply': '回复',
  'action:viewEdit': '查看和编辑',
  'action:enable': '上线',
  'action:disable': '下线',
  'action:changeMobile': '修改手机号',
  'action:fix': '修复',
  'action:jobConfig': '任务配置',
  'action:testSend': '测试发送',
  'action:smsTestSend': '测试发送短信',
  'action:sms': '短信',

  'enum:joined': '已加入',
  'enum:removed': '已移除',

  'enum:auditStatus0': '初始状态',
  'enum:auditStatus1': '待审核',
  'enum:auditStatus2': '待修改',
  'enum:auditStatus3': '审核通过',
  'enum:auditStatus4': '审核拒绝',
  'enum:auditStatus5': '待签约',

  'enum:userStatus0': '正常',
  'enum:userStatus1': '锁定',
  'enum:customerStatus1': '正常',
  'enum:customerStatus2': '锁定',
  'enum:customerStatus3': '拉黑',
  'enum:customerStatus4': '注销',
  'enum:customerStatus5': '已审核',

  'enum:reviewStatus1': '已审核',
  'enum:reviewStatus0': '未审核',


  'enum:flatAccountType1': '正常还款',
  'enum:flatAccountType2': '抹除罚息',
  'enum:flatAccountType3': '补充还款',
  'enum:flatAccountType4': '工资抵扣',
  'enum:flatAccountType5': '营销预算',
  'enum:flatAccountType6': '测试订单',
  'enum:flatAccountType7': '免支付手续费',

  'enum:result0': '失败',
  'enum:result1': '成功',

  'enum:interestStatus1': '感兴趣',
  'enum:interestStatus2': '不感兴趣',
  'enum:interestStatus3': '延后',
  'enum:visitResult0': '待签约',
  'enum:visitResult1': '签约中',
  'enum:visitResult2': '已签约',
  'enum:visitResult0': '待签约',
  'enum:visitResult1': '签约中',
  'enum:isEffective0': '无效',
  'enum:isEffective1': '有效',
  'enum:yes': '是',
  'enum:no': '否',
  'enum:valid': '生效',
  'enum:invalid': '失效',
  'enum:show': '显示',
  'enum:hide': '隐藏',

  'enum:contractStage0': '生成中',
  'enum:contractStage1': '已生成',
  'enum:contractStage2': 'bd已确认',
  'enum:contractStage3': 'b端已签名',
  'enum:contractStage4': 'bd已签名',
  'enum:contractStage5': '修改待b端确认',
  'enum:contractStage6': '结束',

  'enum:riskCode10': '禁止交易',
  'enum:riskCode15': '禁止提现',
  'enum:riskCode19': 'offline',
  
  'merchantCheck:search:storeId': '店铺Id',
  'merchantCheck:search:storeName': '店铺名称',
  'merchantCheck:search:merchantMobile': '商户手机号',
  'merchantCheck:search:merchantId': '商户Id',
  'merchantCheck:search:createTime': '提交审核的时间',
  'merchantCheck:search:beenReviewed': '初次上架是否经过信审',
  'merchantCheck:detail:section0:title': '附加信息',
  'merchantCheck:detail:registerTime': '注册时间',
  'merchantCheck:detail:registerPhone': '注册手机号',
  'merchantCheck:detail:submitPhone': '提交手机号',
  'merchantCheck:detail:applyTime': '申请时间',
  'merchantCheck:detail:isOpen': '是否上架',
  'merchantCheck:detail:openTime': '上架时间',
  'merchantCheck:detail:bdAccount': '所属BD',
  'merchantCheck:detail:isAlreadyAudit': '初次上架是否经过信审',
  'merchantCheck:detail:riskLevel': '风险等级',
  'merchantCheck:detail:appealPicture': '反馈图片',
  'merchantCheck:detail:appealVideo': '反馈视频',
  'merchantCheck:detail:appealDesc': '文字说明',
  'merchantCheck:detail:appealTime': '商户信息提交时间',
  'merchantCheck:detail:rejectReason': '拒绝原因',

  'userCheck:detail:black': '拉黑',
  'userCheck:detail:blackReason': '拉黑原因',
  'userCheck:detail:blackReason1': '资料作假',
  'userCheck:detail:blackReason2': '年龄不符',
  'userCheck:detail:blackReason3': '冒用他人证件',
  'userCheck:detail:blackReason4': '其他',

  'userCheck:detail:selectRejectReason': '请选择拒绝原因',
  'userCheck:detail:enterRemark': '请添加备注',

  'merchant:table:merchantId': '商户号',
  'merchant:table:merchantNumber': '商户号',
  'merchant:table:merchantName': '商户名称',
  'merchant:table:storeName': '店铺名称',
  'merchant:table:storeCategory': '店铺分类',
  'merchant:table:merchantMobile': '商户手机号',
  'merchant:table:merchantProperty': '店铺类型',
  'merchant:table:photoOfStoreFront': '头图',
  'merchant:table:moreStorePhotos': '更多图',
  'merchant:table:industry': '行业',
  'merchant:table:address': '地址',
  'merchant:table:detailAddress': '详细地址',
  'merchant:table:longLat': '经纬度',
  'merchant:table:longitude': '经度',
  'merchant:table:latitude': '纬度',
  'merchant:table:customerServicePhone': '客服电话',
  'merchant:table:status': '上架状态',
  'merchant:table:createTime': '商户信息提交时间',
  'merchant:table:firstTimeOnline': '首次上线时间',
  'merchant:table:auditResult': '信审审核结果',
  'merchant:table:reviewResult': '审核结果',
  'merchant:table:flowBackStatus': '打回状态',
  'merchant:table:fee': '费率',
  'merchant:table:accountPeriod': '账期',
  'merchant:table:bdNumber': '所属BD号',
  'merchant:table:bdName': 'BD姓名',
  'merchant:table:bdID': 'BD ID',
  'merchant:table:bdMobile': 'BD手机号',
  'merchant:table:lastModified': '上一次修改者',
  'merchant:table:lastModifiedTime': '上一次修改时间',
  'merchant:table:operation': '操作',
  'merchant:table:riskTime': '风险预警时间',
  'merchant:table:riskLevel': '风险等级',
  'merchant:table:remark': '备注',
  'merchant:table:switch': '开关',
  'merchant:table:showCartoonPhoto': '显示卡通图',
  'merchant:table:showRealPhoto': '显示真实图',
  'merchant:table:isSupportTakeaway': '是否支持外卖',
  'merchant:table:merchantSource': '商户来源',
  'merchant:table:chainStoresNum': '菲律宾连锁店数量',
  'merchant:table:contacts': '联系人',
  'merchant:table:contactName': '联系人[n]姓名',
  'merchant:table:contactMobile': '联系人[n]手机号',
  'merchant:table:contactEmail': '联系人[n]邮箱',
  'merchant:table:id': '序号',
  'merchant:table:smsCode': '验证码',
  'merchant:table:smsContent': '短信内容',
  'merchant:table:sendTime': '发送时间',
  'merchant:table:workOrderNumber': '工单号',
  'merchant:table:workOrderContent': '跟进问题',
  'merchant:table:workOrderLevel': '紧急程度',
  'merchant:table:workOrderLevel0': 'Low',
  'merchant:table:workOrderLevel1': 'Middle',
  'merchant:table:workOrderLevel2': 'High',
  'merchant:table:workOrderProcess': '是否处理',
  'merchant:table:workOrderProcess0': '未处理',
  'merchant:table:workOrderProcess1': '已处理',
  'merchant:table:workOrderResult': '处理结果',
  'merchant:table:selectedReason': '推荐语',
  'merchant:table:auditName': '审核人',
  'merchant:table:auditTime': '审核时间',
  'merchant:table:rejectReason': '拒绝原因',
  'merchant:table:merchantRejectReason': '商户拒绝原因',
  'merchant:table:auditRejectReason': '信审拒绝原因',
  'merchant:table:businessHours': '营业时间',
  

  'merchant:detail:tab1': '基本信息',
  'merchant:detail:tab2': '交易信息',
  'merchant:detail:tab3': '关联信息',
  'merchant:detail:tab4': '风险信息',
  'merchant:detail:tab5': 'BD拜访记录',
  'merchant:detail:tab6': '拓展信息',
  'merchant:detail:tab7': '交易记录',
  'merchant:detail:tab8': '工单跟进记录',
  'merchant:detail:tab9': '商户操作记录',

  'merchant:detail:applyDate': '交易时间',
  'merchant:detail:applyCount': '发起笔数',
  'merchant:detail:applyUserCount': '发起人数',
  'merchant:detail:applyAmount': '发起金额',
  'merchant:detail:realCount': '实际交易笔数',
  'merchant:detail:realUserCount': '实际交易人数',
  'merchant:detail:realAmount': '实际交易金额',
  'merchant:detail:withdrawCount': '提现笔数',
  'merchant:detail:withdrawAmount': '提现金额',
  'merchant:detail:remainAmount': '商户可用余额',
  'merchant:detail:receiptUserCount': '到账单日的用户数',
  'merchant:detail:receiptTransCount': '到账单日的账单数',
  'merchant:detail:overdueOccurredTransCount': '到账单日且发生过逾期的账单数',
  'merchant:detail:receiptUserCountRate': '到账单日且发生过逾期的账单比例',
  'merchant:detail:overdueTransCount': '逾期且未结清的账单数',
  'merchant:detail:receiptTransCountRate': '逾期且未结清的账单比例',
  'merchant:detail:withdrawTitle': '提现记录',
  'merchant:detail:consumeTitle': '消费记录',
  'merchant:detail:withdrawAmount2': '提现金额',
  'merchant:detail:withdrawTime': '提现时间',
  'merchant:detail:withdrawFailReason': '失败原因',

  'merchant:detail:interestStatus': '商户态度',
  'merchant:detail:visitTime': '拜访时间',
  'merchant:detail:isEffective': '是否有效拜访',
  'merchant:detail:materialUrl': '物料',
  'merchant:detail:storeOwnerName': '店主姓名',
  'merchant:detail:storeOwnerMobile': '店主手机号',
  'merchant:detail:visitResult': '拜访结果',
  'merchant:detail:nextVisitPlan': '预计下一次拜访计划',
  'merchant:detail:nextVisitTime': '预计下一次拜访时间',

  'merchant:detail:availableBalance': '可提现金额',
  'merchant:detail:withdrawalAmount': '提现在途金额',
  'merchant:detail:amountHeld': '还未结算给商户的金额',
  'merchant:detail:merchantCreditAmount': '商户到账金额',
  'merchant:detail:sourceAmount': '用户消费金额',

  'merchant:detail:openingDays': '营业日期',
  'merchant:detail:openingDays1': '每一天',
  'merchant:detail:openingDays2': '选择日期',
  'merchant:detail:openingHours': '营业时间',
  'merchant:detail:openingHours1': '24小时',
  'merchant:detail:openingHours2': '选择时间',
  'merchant:detail:openingHoursTip': '营业时间最多可设置3段时间',

  'order:table:orderId': '订单号',
  'order:table:transactionId': '交易号',
  'order:table:transactionNumber': '交易单号',
  'order:table:transactionName': '交易名称',
  'order:table:voghionOrderId': '电商订单号',
  'order:table:serialNumber': '第三方订单号',
  'order:table:payThirdPartSerialNumber': '支付第三方订单号',
  'order:table:payTransactionId': '支付系统订单号',
  'order:table:userName': '客户姓名',
  'order:table:mobile': '客户手机号',
  'order:table:idNumber': '身份证号',
  'order:table:amount': '总金额',
  'order:table:amount1': '交易金额',
  'order:table:principal': '本金',
  'order:table:interest': '利息',
  'order:table:penaltyInterest': '罚息',
  'order:table:paidPrincipal': '已还本金',
  'order:table:paidInterest': '已还利息',
  'order:table:paidPenaltyInterest': '已还罚息',
  'order:table:remainingAmount': '剩余应还金额',
  'order:table:flatAccountAmount': '还款金额',
  'order:table:flatType': '账户类型',
  'order:table:bankSerialNo': '银行流水号',
  'order:table:bankCredentialImgUrl': '凭证',
  'order:table:remark': '备注',
  'order:table:operateName': '操作人',
  'order:table:flatAccountType': '类型',
  'order:table:operateTime': '操作时间',
  'order:table:result': '结果',
  'order:operate:flatAccount': '平账',
  'order:table:refundStatus': '退款状态',
  'order:table:refundStatus0': '待处理',
  'order:table:refundStatus1': '退款成功',
  'order:table:refundStatus2': '退款失败',
  'order:table:refundStatus3': '退款中',
  // 'order:table:refundStatus3': 'B端退款失败',
  // 'order:table:refundStatus4': 'C端退款失败',
  'order:table:isRefund': '是否退款',
  'order:table:refundAmount': '退款金额',
  'order:table:refundId': '退款单号',
  'order:table:refundTime': '退款时间',
  'order:table:merchantWithdrawalAmount': '商户可用余额',
  'order:table:actualLoanAmount': '用户实际消费金额',
  'order:table:loanAmount': '用户消费金额',
  'order:table:orderAmount': '用户订单金额',
  'order:table:actualPayAmount': '用户实际支付金额',
  'order:table:discountAmount': '优惠券金额',
  'order:table:remainingRefundAmount': '剩余可退金额',
  'order:table:consumptionTime': '消费时间',
  'order:table:merchantResult': '商户退款结果',
  'order:table:clientResult': 'MPay退款结果',
  'order:table:transactionStatus': '订单状态',
  'order:table:transactionStatus0': '待放款',
  'order:table:transactionStatus1': '放款成功',
  'order:table:transactionStatus2': '放款失败',
  'order:table:transactionStatus3': '放款关闭',
  'order:table:transactionStatus4': '全额退款',
  'order:table:transactionStatus5': '部分退款',
  'order:table:payOrderStatus': '订单状态',
  'order:table:payOrderStatus0': '待支付',
  'order:table:payOrderStatus1': '支付成功',
  'order:table:payOrderStatus2': '支付失败',
  'order:table:payOrderStatus3': '订单关闭',
  'order:table:payOrderStatus4': '全额退款',
  'order:table:payOrderStatus5': '部分退款',
  'order:table:payOrderStatus6': 'VCC撤销',
  'order:table:payOrderStatus7': 'VCC退款',
  'order:table:withdrawStatus': '提现状态',
  'order:table:withdrawStatus0': '待处理',
  'order:table:withdrawStatus1': '成功',
  'order:table:withdrawStatus2': '失败',
  'order:table:withdrawStatus3': '关闭',
  'order:table:withdrawStatus4': '全额退款',
  'order:table:withdrawStatus5': '部分退款',
  'order:operate:applayRefund': '申请退款',
  'order:table:transactionType': '交易类型',
  'order:table:transactionOrderType': '交易类型',
  'order:table:transactionType1': '消费订单',
  'order:table:transactionType2': '拆分订单',
  'order:table:transactionType3': '提现订单',
  'order:table:transactionType4': '分期订单',
  'order:table:transactionType5': '分期子订单',
  'order:table:transactionType6': '还款订单',
  'order:table:transactionType7': '奖励订单',
  'order:table:transactionType8': '退款订单',
  'order:table:transactionType9': '取现手续费',
  'order:table:transactionApplicationTime': '交易申请时间',
  'order:table:transactionEndTime': '交易结束时间',
  'order:table:auditStatus': '审核结果',
  'order:table:auditStatus0': '待审核',
  'order:table:auditStatus1': '审核通过',
  'order:table:auditStatus2': '审核拒绝',
  'order:table:auditStatus3': '关单',
  'order:table:failReason': '失败原因',

  'order:table:orderType': '订单类型',
  'order:table:orderType1': '消费订单',
  'order:table:orderType2': '话费充值订单',
  'order:table:orderType3': 'Voghion电商订单',
  'order:table:orderType4': '外卖订单',
  'order:table:orderType5': 'Utility订单',
  'order:table:orderType6': '取现',
  'order:table:orderType7': '扫码',
  'order:table:orderType8': '保证金',
  'order:table:orderType9': 'E-Voucher',
  'order:table:orderType10': 'VCC开卡订单',
  'order:table:orderType11': 'VCC关卡订单',
  'order:table:orderType12': 'VCC交易',
  'order:table:orderType13': '优惠券包',
  'order:table:orderType14': '开卡费',
  'order:table:orderType15': 'QRPH P2M',
  'order:table:orderType16': 'V-Pass',
  'order:table:orderType17': '开mocasa card订单',
  'order:table:orderType18': '开gift card订单',
  'order:table:orderType19': 'gift card交易订单',
  'order:table:orderType20': 'mocasa card 交易订单',
  'order:table:orderType21': '信用报告',
  'order:table:orderType22': '保险',
  'order:table:payTime': '支付时间',
  'order:table:payChannel': '支付渠道',

  'order:table:detail:goodsAmount': '商品金额',
  'order:table:detail:serviceFee': '业务附加费',
  'order:table:detail:discountAmount': '业务优惠',
  'order:table:detail:paymentAmount': '支付金额',
  'order:table:detail:orderAmount': '订单金额',
  'order:table:detail:orderAmount2': '订单金额',
  'order:table:detail:supplierName': '第三方供应商名字',
  'order:table:detail:serialNum': '系统编号',
  'order:table:detail:otherNum': '第三方编号',
  'order:table:detail:merchantId': '商户ID',
  'order:table:detail:merchantName': '商户名称',
  'order:table:detail:customerParam': '订单详情（用户输入）',
  'order:table:detail:errorJson': '订单处理结果',
  'order:table:detail:amountDialogTitle': '订单金额详情',
  'order:table:detail:supplierDialogTitle': '供应商详情',
  'order:table:detail:associateTrxnDialogTitle': '关联交易',
  'order:table:detail:orderDetailDialogTitle': '订单详情',
  'order:table:detail:channelDialogTitle': '渠道详情',
  'order:table:detail:repayOrderAmountDialogTitle': '还款订单金额详情',

  'order:withdraw:table:applicationTime': '申请时间',
  'order:withdraw:table:withdrawalAmount': '提现金额',
  'order:withdraw:table:platformFee': '平台费用',
  'order:withdraw:table:actualLoanAmount': '实际贷款金额',
  'order:withdraw:table:paymentType': '放款类型',
  'order:withdraw:operate:payment': '放款',
  'order:withdraw:operate:cancel': '取消放款',

  'dept:table:departmentParentId': '所属上级',
  'dept:table:departmentParentName': '上级部门',
  'dept:table:departmentId': '部门ID',
  'dept:table:departmentName': '部门名称',
  'dept:table:memberCount': '部门成员',
  'dept:table:sort': '排序',
  'dept:table:remark': '备注',
  'dept:table:deptManage': '部门管理',
  'dept:table:keywordsFilter': '输入关键字进行过滤',
  'dept:table:bdAppDisplay': 'BD app 是否展示',
  'dept:table:bdAppDisplay0': '不展示',
  'dept:table:bdAppDisplay1': '展示',

  'sys:user:keywords': '关键词',
  'sys:user:dept': '部门',
  'sys:user:superior': '所属上级',
  'sys:user:area': '负责区域',
  'sys:user:numberOfStores': '负责店铺数量',
  'sys:user:name': '姓名',
  'sys:user:role': '角色',
  'sys:user:userStatus': '用户状态',
  'sys:user:phone': '手机号',
  'sys:user:entryTime': '入职时间',
  'sys:user:resignationTime': '离职时间',
  'sys:user:workNumber': '工号',
  'sys:user:userName': '账户名',
  'sys:user:realName': '姓名',
  'sys:user:mobile': '手机号',
  'sys:user:email': '邮箱',
  'sys:user:department': '所属部门',
  'sys:user:parentDepartment': '所属父部门',
  'sys:user:lastLoginTime': '最后登陆时间',
  'sys:user:password': '账户密码',
  'sys:user:password2': '确认密码',

  'sys:menu:name': '名称',
  'sys:menu:menuName': '菜单名称',
  'sys:menu:menuIcon': '菜单图标',
  'sys:menu:menuType': '菜单类型',
  'sys:menu:parentMenu': '上级菜单',
  'sys:menu:menuUrl': '菜单URL',
  'sys:menu:menuPermissionCode': '授权标识',
  'sys:menu:menuSort': '排序',
  'sys:menu:menuType0': '目录',
  'sys:menu:menuType1': '菜单',
  'sys:menu:menuType2': '按钮',

  'user:table:userId': '用户ID',
  'user:table:userName': '用户姓名',
  'user:table:email': '用户邮箱',
  'user:table:userMobile': '用户手机号',
  'user:table:userSex': '性别',
  'user:table:currentQuota': '当前额度',
  'user:table:usedQuota': '已用额度',
  'user:table:outstandingQuota': '未还额度',
  'user:table:product': '产品',
  'user:table:registerTime': '注册时间',
  'user:table:appCode': 'App Code',
  'user:table:systemType': '系统类型',
  'user:table:registerInviteCode': '注册邀请码',
  'user:table:authorization': '数据三方授权',
  'user:table:authorization0': '未授权',
  'user:table:authorization1': '已授权',
  'user:table:authorizationTime': '数据三方授权时间',
  'user:table:raiseAmount': '调整金额到',
  'user:table:effectiveDate': '生效日期',
  'user:table:reason': '原因说明',
  'user:table:logoutReason': '注销原因',
  'user:table:depositInfo:rechargeAmount': '担保金充值金额',
  'user:table:depositInfo:depositAmount': '担保金金额',
  'user:table:depositInfo:activeAmount': '担保金激活金额',
  'user:table:depositInfo:guaranteeRate': '担保金比例',
  'user:table:giftCardInfo:giftCardTotalAmount': '礼品卡充值金额',
  'user:table:giftCardInfo:giftCardAvailableAmount': '礼品卡可用金额',
  'user:table:giftCardInfo:templateId': '模版ID',
  'user:table:giftCardInfo:totalAmount': '总金额',
  'user:table:giftCardInfo:availableAmount': '剩余金额',
  'user:table:giftCardInfo:status0': '未激活',
  'user:table:giftCardInfo:status1': '已激活',
  'user:table:giftCardInfo:status2': '禁用',
  'user:table:giftCardInfo:status3': '超时未激活',
  'user:table:giftCardInfo:activationDate': '激活时间',
  'user:table:giftCardInfo:activationDueDate': '激活到期时间',
  'user:table:originMobile': '原手机号',
  'user:table:replaceMobile': '新手机号',
  
  'user:detail:tab1': '基本信息',
  'user:detail:tab2': '审核信息',
  'user:detail:detailInfoTab': '用户信息',
  'user:action:bindReferralCode': '绑定邀请码',
  'user:detail:enterNewReferralCode': '输入新推荐码',
  'user:detail:referralCodeFormatTip': '五位数字或大写字母',
  'user:detail:reIssueReferralBonus': '补发推荐奖励',
  'user:detail:reIssueReferralBonusDefault': '补发推荐奖励\n*输入推荐码后自动检索',
  'user:detail:noRewardFound': '该码无奖励',
  'user:detail:userCreatedInviteCode': '用户创建的邀请码',
  'user:detail:confirmToBind': '确认绑定',
  'user:detail:bindReferralCodeWarning': '推荐码与用户绑定后不支持修改或取消',
  'user:detail:submitInfoTab': '授信记录',
  'user:detail:financeUserInfoTab': '金融用户信息',
  'user:detail:financeUserInfo:id': '金融用户ID',
  'user:detail:financeUserInfo:createUserId': '创建用户ID',
  'user:detail:applyRecord': '预批核申请记录',
  'user:detail:partnerLoanRecord': '甲方贷款记录',
  'user:detail:depositInfoTab': '担保金信息',
  'user:detail:creditInfoTab': '额度信息', // 原信用申请进度
  'user:detail:giftCardTab': '礼品卡信息',
  'user:detail:couponTab': '优惠券信息',
  'user:detail:consumeTab': '订单记录',
  'user:detail:transactionTab': '交易记录',
  'user:detail:repaymentTab': '还款',
  'user:detail:billTab': '账单',
  'user:detail:installmentTab': '分期记录',
  'user:detail:bnplRecommitTime': 'bnpl重提时间',
  'user:detail:qlRecommitTime': 'ql重提时间',
  'user:detail:viewRepaymentCode': '查看还款码',
  
  'user:detail:submitInfo:configType': '类型',
  'user:detail:submitInfo:status': '状态',
  'user:detail:submitInfo:auditTime': '审核时间',
  'user:detail:submitInfo:createTime': '创建时间',

  'user:detail:transactionRecord:merchantId': '店铺ID',
  'user:detail:transactionRecord:merchantName': '店铺名称',
  'user:detail:transactionRecord:orderType': '订单类型',
  'user:detail:transactionRecord:orderName': '订单名称',
  'user:detail:transactionRecord:orderAmount': '订单金额',
  'user:detail:transactionRecord:orderTime': '订单时间',
  'user:detail:transactionRecord:serialNum': '订单号',
  'user:detail:transactionRecord:thirdPartSerialNumber': '第三方订单号',
  'user:detail:transactionRecord:payAmount': '支付金额',
  'user:detail:transactionRecord:payThirdPartSerialNumber': '支付订单号',
  'user:detail:transactionRecord:payTransactionId': '支付系统订单号',
  'user:detail:transactionRecord:payTime': '支付时间',
  'user:detail:transactionRecord:payMode': '支付供应商-支付渠道',
  'user:detail:transactionRecord:orderStatus': '订单状态',
  'user:detail:transactionRecord:refundTime': '退款时间',
  'user:detail:transactionRecord:refundAmount': '退款金额',
  'user:detail:transactionRecord:customerParam': '订单详情（用户输入）',
  'user:detail:transactionRecord:errorJson': '用户输入第三方失败原因',
  'user:detail:transactionRecord:supplier': '第三方供应商',
  'user:detail:transactionRecord:associateTrxn': '关联交易',

  'user:detial:quickLoan:currentOrder': '当前订单',
  'user:detial:quickLoan:historyOrder': '历史订单',
  'user:detial:quickLoan:statementDate': '到期日',
  'user:detial:quickLoan:overdueDays': '逾期天数',
  
  'user:detial:parntnerLoan:partnerId': 'Partner ID',
  'user:detial:parntnerLoan:partnerName': 'Partner Name',
  'user:detial:parntnerLoan:applyStatus': '申请状态',
  'user:detial:parntnerLoan:loanStatus': '预批核状态',
  'user:detial:parntnerLoan:loanStatus1': '申请中',
  'user:detial:parntnerLoan:loanStatus2': '成功',
  'user:detial:parntnerLoan:loanStatus3': '拒绝',
  'user:detial:parntnerLoan:loanStatus4': '撞库拒绝',
  'user:detial:parntnerLoan:loanStatus5': '假证',
  'user:detial:parntnerLoan:creditResult': '预批核结果',
  'user:detial:parntnerLoan:creditLine': '预批核额度',
  'user:detial:parntnerLoan:finishStatus': '完成状态',
  'user:detial:parntnerLoan:finishStatus0': '未完成',
  'user:detial:parntnerLoan:finishStatus1': '已完成',
  'user:detial:parntnerLoan:createTime': '创建时间',
  'user:detial:parntnerLoan:updateTime': '更新时间',
  'user:detial:parntnerLoan:partnerLoanAmount': '贷款金额',
  'user:detial:parntnerLoan:repayStatus': '状态',
  'user:detial:parntnerLoan:repayStatus0': '待还款',
  'user:detial:parntnerLoan:repayStatus1': '已结清',
  'user:detial:parntnerLoan:loanDate': '贷款日期',
  'user:detial:parntnerLoan:dueDate': '逾期日期',
  

  'credit:detail:creditLine': '总额度',
  'credit:detail:usedLine': '已用额度',
  'credit:detail:availableLine': '剩余可用额度',
  'credit:detail:enchashmentCredit': '取现额度',
  'credit:detail:usedEnchashmentCredit': '已用取现额度',
  'credit:detail:availableEnchashmentCredit': '剩余可用取现额度',
  'credit:detail:vccLine': 'vcc额度',
  'credit:detail:usedVccLine': '已用vcc额度',
  'credit:detail:availableVccLine': '剩余可用vcc额度',
  'credit:detail:overflowAmt': '溢出金',
  'credit:detail:stage': '阶段',
  'credit:detail:stage1': '授信阶段',
  'credit:detail:stage2': '提额阶段',
  'credit:detail:pageId': '授信页面',
  'credit:detail:name': '用户名称',
  'credit:detail:status': '状态',
  'credit:detail:applyTime': '申请时间',
  'credit:detail:auditTime': '审批时间',
  'credit:detail:rejectReason': '拒绝原因',
  'credit:detail:lineChange': '变更金额',
  'credit:detail:lineBefore': '变更前金额',
  'credit:detail:lineAfter': '变更后金额',
  'credit:detail:changeTime': '变更时间',
  'credit:detail:changeAmount': '变更余额',
  'credit:detail:latestBalance': '最新余额',
  'credit:detail:creditLimitChangeRecord':'授信额度变更记录',
  'credit:detail:withdrawalChangeRecord':'取现额度变更记录',
  'credit:detail:creditLimitUseRecord':'授信额度使用记录',

  'coupon:detail:type': '优惠券类型',
  'coupon:detail:type1': '满减券',
  'coupon:detail:type2': '免息券',
  'coupon:detail:amount': '优惠券金额',
  'coupon:detail:distributeTime': '发放时间',
  'coupon:detail:used': '是否使用',
  'coupon:detail:useTime': '使用时间',
  'coupon:detail:useRule': '使用规则',

  'repayment:detail:applyAmount': '还款发起金额',
  'repayment:detail:realAmount': '实际支付金额',
  'repayment:detail:repaymentStatus': '还款状态',
  'repayment:detail:repaymentStatus0': '初始化',
  'repayment:detail:repaymentStatus1': '还款中',
  'repayment:detail:repaymentStatus2': '还款成功',
  'repayment:detail:repaymentStatus3': '还款失败',
  'repayment:detail:tradeFinishTime': '还款完成时间',
  'repayment:detail:paySerialNo': '流水号',
  'repayment:detail:payChannel': '支付通道',
  'repayment:detail:payMode': '支付方式',
  
  'repayment:detail:nextRepaymentPlanTimee': '下一次账期',
  'repayment:detail:unOutAccountAmount': '未出账金额',
  'repayment:detail:billTime': '帐期',
  'repayment:detail:billStartTime': '帐单开始时间',
  'repayment:detail:billEndTime': '帐单结束时间',
  'repayment:detail:isInstallment': '是否分期',
  'repayment:detail:isRefund': '是否还款',
  'repayment:detail:installPeriod': '分期期数',
  'repayment:detail:billAmount': '账单金额',
  'repayment:detail:principal': '本金',
  'repayment:detail:interest': '利息',
  'repayment:detail:charge': '手续费',
  'repayment:detail:penaltyInterest': '罚息',
  'repayment:detail:statementPrincipal': '账单本金',
  'repayment:detail:statementInterest': '利息',
  'repayment:detail:statementFee': '费',
  'repayment:detail:repaymentBeforeStatement': '还款',
  'repayment:detail:installServiceFee': '分期手续费',
  'repayment:detail:repayAmount': '还款金额',
  'repayment:detail:paidTotalAmount': '账单已付金额',
  'repayment:detail:contractSerialNo': '合同编号',
  'repayment:detail:status': '还款状态',
  'repayment:detail:status1': '待还款',
  'repayment:detail:status2': '逾期',
  'repayment:detail:status3': '已分期',
  'repayment:detail:status4': '已还清',
  'repayment:detail:status5': '最小还款',
  'repayment:detail:statusNew1': '待还款',
  'repayment:detail:statusNew2': '满足最小还款',
  'repayment:detail:statusNew3': '已结转',
  'repayment:detail:statusNew4': '结清',
  'repayment:detail:statusNew5': '逾期',
  'repayment:detail:expireTime': '还款截止时间',
  'repayment:detail:refundTime': '还款时间',
  'repayment:detail:clickViewConsumptionRecord': '点击查看消费记录',
  'repayment:detail:processFee': '还款手续费',
  'repayment:detail:channel': '还款通道',
  'repayment:detail:actionDetail': '平账明细',
  'repayment:detail:requestAmount': '请求金额',
  'repayment:detail:tradingChannel': '交易渠道',
  'repayment:detail:paymentId': '支付号',
  'repayment:detail:statementBeginDate': '账单账期',
  'repayment:detail:statementDate': '出账日',
  'repayment:detail:statementBalance': '账单金额',
  'repayment:detail:statementDue': '账单欠款',
  'repayment:detail:statementStatus': '账单状态',
  'repayment:detail:settleAmount': '平账金额',
  'repayment:detail:settleTime': '平账时间',
  'repayment:detail:repaymentOrder': '还款订单',
  'repayment:detail:detailInfo': '账单详情',
  'repayment:detail:fee': '费',
  'repayment:detail:penalty': '罚息',
  'repayment:detail:detailTotal': '金额汇总',
  'repayment:detail:detailTotal2': '出账金额汇总',
  'repayment:detail:transactionList': '交易流水列表',
  'repayment:detail:nextRepaymentPlanTime': '出账日',
  'repayment:detail:dueDate': '还款日',
  'repayment:detail:minRepaymentAmount': '最小还款',
  'repayment:detail:totalDue': '总应还',
  'repayment:detail:totalBalance': '总欠款',
  'repayment:detail:paidTotalAmount': '出账后还款',
  'repayment:detail:settledRepayment': '已平账金额',
  'repayment:detail:outstandingBalance': '账单剩余未还',
  'repayment:detail:settledRepaymentDetail': '已平账金额详情',

  'installment:detail:installmentAmount': '分期金额',
  'installment:detail:accountingPeriod': '账期',
  'installment:detail:interestRate': '日利率',
  'installment:detail:duration': '分期付款期限',
  'installment:detail:principal': '本金',
  'installment:detail:interest': '利息',
  'installment:detail:installmentPrincipal': '分期付款本金',
  'installment:detail:installmentInterest': '分期付款利息',
  'installment:detail:deadline': '还款截止日',

  'installment:detail:detailInfo': '分期详情',
  'installment:detail:installType': '分期类型',
  'installment:detail:installType1': '账单分期',
  'installment:detail:installType2': '消费分期',
  'installment:detail:createTime': '分期发起时间',
  'installment:detail:installAmount': '分期总金额',
  'installment:detail:stage': '分期总期数',
  'installment:detail:repaymentStatus': '分期状态',
  'installment:detail:repaymentStatus1': '进行中',
  'installment:detail:repaymentStatus4': '已完成',
  'installment:detail:currentPeriodStage': '分期进度',
  'installment:detail:repaymentAmount': '还款总金额',
  'installment:detail:plan': '分期计划',
  'installment:detail:planTotal': '分期计划汇总',
  'installment:detail:planDetail': '分期计划详情',
  'installment:detail:firstPay': '分期首付',
  'installment:detail:totalPrincipal': '分期本金合计',
  'installment:detail:totalFee': '分期费合计',
  'installment:detail:totalInterest': '分期利息合计',
  'installment:detail:totalDiscount': '分期优惠合计',
  'installment:detail:period': '期数',
  'installment:detail:settleDate': '出账日',
  'installment:detail:principal': '本金',
  'installment:detail:fee': '费',
  'installment:detail:interest': '利息',
  'installment:detail:discount': '优惠',
  
  'depositRefund:detail:table': '保证金退款',
  'depositRefund:detail:createTime': '发起时间',
  'depositRefund:detail:financeOrderIds': '原保证金ID',
  'depositRefund:detail:depositAmount': '保证金金额',
  'depositRefund:detail:refundMethod': '申请类型',
  'depositRefund:detail:realAmount': '到账金额',
  'depositRefund:detail:lineBefore': '变更前额度',
  'depositRefund:detail:lineAfter': '变更后额度',
  'depositRefund:detail:transferType': '退款处理类型',
  'depositRefund:detail:creditedDate': '发起退款时间',
  'depositRefund:detail:payOrderNo': '支付流水号',
  'depositRefund:detail:status': '退款状态',
  'depositRefund:detail:status-1': '待发起退款',
  'depositRefund:detail:status0': '待退款',
  'depositRefund:detail:status1': '退款成功',
  'depositRefund:detail:status2': '退款失败',
  'depositRefund:detail:status3': '走oa转账',
  'depositRefund:detail:updateTime': '状态更新时间',
  'depositRefund:detail:accountType': '备用账户类型',
  'depositRefund:detail:realAccountNo': '备用账号码',
  'depositRefund:detail:reason': '退款原因',
  'depositRefund:detail:suggestions': '用户建议',

  'qrph:qrCode': 'QR源码',
  'qrph:qrContent': '解析信息',

  'shortLink:shortUrl': '短链接',
  'shortLink:originUrl': '原始链接',
  'shortLink:purpose': '用途',
  'shortLink:linksNumber': '链接数',

  'faq:title': 'FAQ标题',
  'faq:content': 'FAQ正文',
  'faq:contentView': 'FAQ正文预览',
  'faq:category': '类目',
  'faq:keyword': '关键字',
  'faq:isValid': '可见状态',
  'faq:top': '置顶状态',
  'faq:helpfulNumber': '有助人数',
  'faq:uselessNumber': '无用人数',

  'product:enterSearch': '请输入关键词搜索',
  'product:addCategoryBtn': '新增分类',
  'product:addBrandBtn': '新增品牌',
  'product:addProductBtn': '新增产品',
  'product:categoryName': '分类名',
  'product:productEntry': '产品入口',
  'product:categoryOrder': '排序',
  'product:order': '排序',
  'product:category': '类型',
  'product:categoryIcon': '分类图标',
  'product:status': '状态',
  'product:status0': '已下线',
  'product:status1': '已上线',
  'product:sureEnableTip': '上线前请确认详情',
  'product:sureDisableTip': '确认下线吗',
  'product:brand': '品牌',
  'product:brandName': '品牌名称',
  'product:brandLogo': '品牌Logo',
  'product:productName': '产品名称',
  'product:channel': '供应商',

  'order:quickLoan:userName': '申请人名称',
  'order:quickLoan:loanSerialNumber': '贷款编号',
  'order:quickLoan:applyDate': '申请时间',
  'order:quickLoan:disbursementDate': '打款时间',
  'order:quickLoan:completeDate': '完成时间',
  'order:quickLoan:applyAmount': '申请金额',
  'order:quickLoan:receiveAmount': '收到金额',
  'order:quickLoan:status': '贷款状态', 
  'order:quickLoan:status0': '提交',
  'order:quickLoan:status1': '审核中',
  'order:quickLoan:status2': '放款中',
  'order:quickLoan:status3': '待还款',
  'order:quickLoan:status4': '完成',
  'order:quickLoan:status5': '拒绝',
  'order:quickLoan:status6': '申请关闭',
  'order:quickLoan:loanPayoutView': '出款记录',
  'order:quickLoan:loanId': '贷款Id',
  'order:quickLoan:productId': '产品Id',
  'order:quickLoan:term': '期数',
  'order:quickLoan:termBeginDate': '期始日期',
  'order:quickLoan:termEndDate': '期终日期',
  'order:quickLoan:repaymentPlan:status': '状态',
  'order:quickLoan:repaymentPlan:status1': '待还',
  'order:quickLoan:repaymentPlan:status2': '逾期',
  'order:quickLoan:repaymentPlan:status3': '结清',
  'order:quickLoan:repaymentPlanView': '还款计划',
  'order:quickLoan:noRepaymentPlan': '暂无还款计划',
  'order:quickLoan:noRepaymentRecord': '暂无还款记录',
  'order:quickLoan:noOrders': '暂无订单',
  'order:quickLoan:orderNumber': '订单号',
  'order:quickLoan:cardNumber': '收款账号',
  'order:quickLoan:cardType': '账号类型',
  'order:quickLoan:transactionNumber': '交易流水号',
  'order:quickLoan:receiptNumber': '出款回执',
  'order:quickLoan:realAmount': '实际出款金额',
  'order:quickLoan:serviceFee': '服务费',
  'order:quickLoan:convenienceFee': '便利费',
  'order:quickLoan:privilegePackFee': '特权包费',
  'order:quickLoan:feeList': '费用列表',
  'order:quickLoan:feeName': '费用名称',
  'order:quickLoan:feeAmount': '费用金额',
  'order:quickLoan:preDiscount': '优惠费用',
  'order:quickLoan:discountInterest': '优惠利息',
  'order:quickLoan:paymentMethod': '支付方式',
  'order:quickLoan:submitDate': '提交时间',
  'order:quickLoan:loanPayout:status': '状态',
  'order:quickLoan:loanPayout:status0': '待放款',
  'order:quickLoan:loanPayout:status1': 'pending',
  'order:quickLoan:loanPayout:status2': '成功',
  'order:quickLoan:loanPayout:status3': '失败',
  'order:quickLoan:loanPayout:status4': '异常',
  'order:quickLoan:loanPaymentView': '还款记录',
  'order:quickLoan:amount': '订单金额',
  'order:quickLoan:settleAmount': '结算金额',
  'order:quickLoan:loanPayment:status': '结果',
  'order:quickLoan:loanPayment:status0': '初始化',
  'order:quickLoan:loanPayment:status1': '还款中',
  'order:quickLoan:loanPayment:status2': '还款成功',
  'order:quickLoan:loanPayment:status3': '还款失败',
  'order:quickLoan:loanPayment:applyDate': '还款时间',
  'order:quickLoan:loanPayment:completeDate': '用户支付时间',
  'order:quickLoan:operate:flatAccount': '平账',
  'order:quickLoan:remainAmount': '剩余金额',
  'order:quickLoan:balanceAmount': '平账金额',
  'order:quickLoan:remark': '备注',
  'order:quickLoan:receivedDate': '放款时间',
  'order:quickLoan:institutionCode': '放款渠道',
  'order:quickLoan:failReason': '失败原因',
  'order:quickLoan:funderId': '资金方Id',
  'order:quickLoan:payoutTransactionVoucher': '放款渠道凭证',
  'order:cashoyoLoan:loanId': '贷款Id',
  'order:cashoyoLoan:loanSerialNo': '贷款编号',
  'order:cashoyoLoan:userType': '用户类型',
  'order:cashoyoLoan:userType1': '普通用户',
  'order:cashoyoLoan:userType2': '内部员工',
  'order:cashoyoLoan:userType3': '审核员',
  'order:cashoyoLoan:productId': '产品Id',
  'order:cashoyoLoan:principalPoolSessionCode': '资金池批次',
  'order:cashoyoLoan:payeeAccountNumber': '收款账号',
  'order:cashoyoLoan:days': '借款天数',
  'order:cashoyoLoan:applyAmount': '申请金额',
  'order:cashoyoLoan:serviceFee': '服务费',
  'order:cashoyoLoan:convenienceFee': '手续费',
  'order:cashoyoLoan:amount': '到账金额',
  'order:cashoyoLoan:remainingRepaymentAmount': '剩余还款金额',
  'order:cashoyoLoan:applyTime': '申请时间',
  'order:cashoyoLoan:approvalTime': '交易批准时间',
  'order:cashoyoLoan:billDueDate': '账单到期日',
  'order:cashoyoLoan:loanReceivedTime': '放款到账时间',
  'order:cashoyoLoan:completeTime': '完成时间',
  'order:cashoyoLoan:createTime': '创建时间',
  'order:cashoyoLoan:updateTime': '更新时间',
  'order:cashoyoLoan:status': '贷款状态',
  'order:cashoyoLoan:status0': '机审中',
  'order:cashoyoLoan:status1': '人审中',
  'order:cashoyoLoan:status2': '审核通过',
  'order:cashoyoLoan:status3': '已放款',
  'order:cashoyoLoan:status4': '已完成',
  'order:cashoyoLoan:status5': '已拒绝',
  'order:cashoyoLoan:status6': '已关闭',
  'order:cashoyoLoan:status7': '已逾期',
  'order:cashoyoLoan:passConfirm': '确认通过该贷款吗？',
  'order:cashoyoLoan:rejectConfirm': '确认拒绝该贷款吗？',
  'order:cashoyoLoan:batchPass': '批量通过',
  'order:cashoyoLoan:batchReject': '批量拒绝',
  'order:cashoyoLoan:humanAuditOnlyTip': '只能操作人审中的贷款，请检查',
  'order:cashoyoLoan:loanInfo': '贷款信息',
  'order:cashoyoLoan:payouts': '出款记录',
  'order:cashoyoLoan:plans': '还款计划',
  'order:cashoyoLoan:repayments': '还款记录',
  'order:cashoyoLoan:statements': '清算记录',
  'order:cashoyoLoan:payoutSerialNumber': '出款流水号',
  'order:cashoyoLoan:payoutReceipt': '出款回执',
  'order:cashoyoLoan:payoutTransactionVoucher': '出款渠道凭证',
  'order:cashoyoLoan:institutionCode': '出款渠道',
  'order:cashoyoLoan:loanAmount': '贷款金额',
  'order:cashoyoLoan:realAmount': '实际金额',
  'order:cashoyoLoan:payoutStatus': '出款状态',
  'order:cashoyoLoan:payoutMessage': '出款消息',
  'order:cashoyoLoan:submitTime': '提交时间',
  'order:cashoyoLoan:planAmount': '应还金额',
  'order:cashoyoLoan:principal': '本金',
  'order:cashoyoLoan:interest': '利息',
  'order:cashoyoLoan:penaltyInterest': '罚息',
  'order:cashoyoLoan:paidPrincipal': '已还本金',
  'order:cashoyoLoan:paidInterest': '已还利息',
  'order:cashoyoLoan:paidPenaltyInterest': '已还罚息',
  'order:cashoyoLoan:interestRate': '利率',
  'order:cashoyoLoan:penaltyRate': '罚息率',
  'order:cashoyoLoan:penaltyTimes': '罚息次数',
  'order:cashoyoLoan:initDueDate': '初始到期日',
  'order:cashoyoLoan:dueDate': '到期日',
  'order:cashoyoLoan:remainingExtensionTimes': '剩余展期次数',
  'order:cashoyoLoan:planStatus': '计划状态',
  'order:cashoyoLoan:planStatus1': '待还',
  'order:cashoyoLoan:planStatus2': '逾期',
  'order:cashoyoLoan:planStatus3': '结清',
  'order:cashoyoLoan:paySerialNo': '支付流水号',
  'order:cashoyoLoan:payOrderNo': '支付订单号',
  'order:cashoyoLoan:repaymentStatus': '还款状态',
  'order:cashoyoLoan:repaymentStatus0': '初始化',
  'order:cashoyoLoan:repaymentStatus1': '处理中',
  'order:cashoyoLoan:repaymentStatus2': '成功',
  'order:cashoyoLoan:repaymentStatus3': '失败',
  'order:cashoyoLoan:payChannel': '支付渠道',
  'order:cashoyoLoan:payMode': '支付方式',
  'order:cashoyoLoan:tradeFinishTime': '交易完成时间',
  'order:cashoyoLoan:remark': '备注',
  'order:cashoyoLoan:settleAmount': '结算金额',
  'order:cashoyoLoan:clearPrincipal': '结清本金',
  'order:cashoyoLoan:clearInterest': '结清利息',
  'order:cashoyoLoan:clearPenaltyInterest': '结清罚息',
  'order:cashoyoLoan:leftPrincipal': '剩余本金',
  'order:cashoyoLoan:leftInterest': '剩余利息',
  'order:cashoyoLoan:leftPenaltyInterest': '剩余罚息',

  'order:debtBuybackTable:time': '批次创建日期',
  'order:debtBuybackTable:funder': '资金方',
  'order:debtBuybackTable:status': '回购状态',
  'order:debtBuybackTable:status1': '等待回购',
  'order:debtBuybackTable:status2': '逾期未回购',
  'order:debtBuybackTable:status3': '完成回购',
  'order:debtBuybackTable:leftDays': '剩余 [n] 天',
  'order:debtBuybackTable:overDueDays': '已逾期 [n] 天',
  'order:debtBuybackTable:cycle': '周期',
  'order:debtBuybackTable:buybackAmount': '回购金额',
  'order:debtBuybackTable:latestOperatorName': '上次操作',
  'order:debtBuybackTable:latestOperatorTime': '操作时间',
  'order:debtBuybackTable:operate': '操作',
  'order:debtBuybackTable:operate:checklist': '下载清单',
  'order:debtBuybackTable:operate:agreement': '下载协议',
  'order:debtBuybackTable:operate:register': '登记回购',
  'order:debtBuybackTable:operate:credentials': '查看凭证',
  'order:debtBuybackTable:operate:registerDialogTitle': '登记回购',  
  'order:debtBuybackTable:operate:credentialsDialogTitle': '回购凭证',  
  'order:debtBuybackTable:quantity': '债权数',
  'order:debtBuybackTable:ticketTip': '上传公对公转账或充值凭证（必填，限图片格式）',
  'order:debtBuybackTable:contractTip': '上传双方已签署的回购协议（必填，限 PDF 格式）',
  'order:debtBuybackTable:warningTip': '你将把该周期内所有逾期债权置为<span class="warning">已回购</span>状态。请再次确认资金方、时间范围、笔数及总金额。',
  'order:debtBuybackTable:completedTip': '[operator] 已于 [operateTime] 回购该批次债权。',
  'order:debtBuybackTable:registerDialog:submit': '确认回购上述债权',
  'order:debtBuybackTable:imgTip': '仅支持以下图片格式: .jpg / .jpeg / .png / .bmp / .tiff / .tif',
  'order:debtBuybackTable:pdfTip': '仅支持 PDF 格式',

  'mpay:transactionFinishDate': '交易时间',
  'mpay:createDate': '创建时间',
  'mpay:cashflow': '现金流',
  'mpay:type': '类型',
  'mpay:merchantName': '商户名称',
  'mpay:institutionName': '机构名称',
  'mpay:institutionAccountName': '机构账号名称',
  'mpay:transactionNumber': '交易订单号',
  'mpay:transactionVoucher': '三方订单号',
  'mpay:processStatus': '对账状态',
  'mpay:status': '状态',
  'mpay:beforeStatus': '未修复前的状态',
  'mpay:channel': '渠道',
  'mpay:originData': '三方原始数据',
  'mpay:remark': '备注',
  'mpay:operatorId': '操作者Id',
  'mpay:operatorName': '操作者名字',
  'mpay:totalMoneyIn': '流入金额',
  'mpay:totalMoneyOut': '流出金额',
  'mpay:totalDiff': '差额',
  'mpay:all:totalMoneyIn': '累计流入',
  'mpay:all:totalMoneyOut': '累计流出',
  'mpay:all:totalDiff': '累计差额',
  'mpay:all:totalDiffIn': '累计净流入',
  'mpay:all:totalDiffOut': '累计净流出',

  'funder:router:name': '资金方',
  'funder:router:expression': '路由表达式',
  'funder:router:lastFunderExpression': '延续上次路由表达式',
  'funder:router:payActive': '还款开关',
  'funder:router:payoutActive': '放款开关',
  'funder:router:listOrder': '排序',

}
export default cn
